module.exports = __webpack_public_path__ + "static/img/pic_no_ranking.c1a60e8c.png";